import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootStore } from '../../redux/store'
import { BaseResponse } from '../../types/base-response'
import { setIsLoading } from '../../redux/reducers/appSettingsReducer'
import { requestsService } from '../../services/requestsService'
import UserErrorMessage from '../../utils/errorFilter'
import { showErrorMessage } from '../../redux/reducers/snackbarReducer'
import { manualRequestsService } from '../../services/myActionsService'
import {RequestDetailResponse} from "../../types/requests"
import {RequestType} from "../../models"
import {statusTranslation} from "../../shared/UI/EventPopup/utils"

export const useCommonDependencies = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const activeRoute = useSelector<RootStore, string>(
    (state: RootStore) => state.appSettings.activeRoute
  )

  return { dispatch, navigate, activeRoute }
}

export const useErrorHandler = () => {
  const { dispatch, navigate, activeRoute } = useCommonDependencies()

  const handleError = (err: any) => {
    setIsLoading(false)
    navigate(activeRoute)
    dispatch(showErrorMessage('An error occurred while fetching the request details.'))
    const response: BaseResponse = err.response.data
    response.errors.forEach((error: any) => {
      dispatch(showErrorMessage(UserErrorMessage(error.name)))
    })
  }

  return handleError
}

export const useRequestChecker = () => {
  const { id: requestId } = useParams<{ id: string }>()
  const checkIfRequestExists = async () => requestsService.checkRequestExists(Number(requestId))
  return checkIfRequestExists
}

export const useNonExistentRequestHandler = () => {
  const { dispatch, navigate } = useCommonDependencies()
  const handleNonExistentRequest = () => {
    dispatch(showErrorMessage('The request has been deleted by the user, and is no longer available for review.'))
    navigate('/myactions')
  }
  return handleNonExistentRequest
}

export const useRequestDetailFetcher = () => {
  const { id: requestId } = useParams<{ id: string }>()
  const fetchRequestDetail = async () =>
    manualRequestsService.getHolidayRequestDetail(requestId as string)
  return fetchRequestDetail
}

export const canSetAmended = (requestDetail: RequestDetailResponse | null): boolean => {
  if (!requestDetail) return false

  switch (requestDetail.requestTypeId) {
    case RequestType.HOLIDAY:
    case RequestType.HOLIDAY_M:
    case RequestType.WORK_FROM_HOME:
    case RequestType.LIEU_DAY:
    case RequestType.LIEU_DAY_M:
    case RequestType.SHIFT:
      return true
    default:
      return false
  }
}

export const calculateStatusLabel = (prop: RequestDetailResponse) => {
  if (!prop?.status || !prop.statusBanner.requestStatus) return

  if (prop?.isQueried) {
    return 'Queried'
  }
  return statusTranslation(prop.statusBanner.requestStatus)
}

export const calculateMaxHeight = (isActionedInfoVisible: any, isCommentsVisible: any, isChangeRequested: any) => {
  let maxHeight

  if (isActionedInfoVisible) {
    maxHeight = isCommentsVisible ? 'calc(100vh - 650px)' : 'calc(100vh - 525px)'
  } else {
    maxHeight = isCommentsVisible ? 'calc(100vh - 565px)' : 'calc(100vh - 440px)'
  }

  if (isChangeRequested) {
    maxHeight = isCommentsVisible ? 'calc(100vh - 855px)' : 'calc(100vh - 730px)'
  }

  return maxHeight
}